var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("toolbar", { attrs: { title: "Add New Load" } }),
      _vm._v(" "),
      _c(
        "v-stepper",
        {
          model: {
            value: _vm.currentStep,
            callback: function($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep"
          }
        },
        [
          _c(
            "v-stepper-header",
            [
              _c(
                "v-stepper-step",
                { attrs: { complete: _vm.currentStep > 1, step: "1" } },
                [_vm._v("\n        Principal Stakeholders\n      ")]
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-stepper-step",
                { attrs: { complete: _vm.currentStep > 2, step: "2" } },
                [_vm._v("\n        Origin, Destination, Time\n      ")]
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-stepper-step",
                { attrs: { complete: _vm.currentStep > 3, step: "3" } },
                [_vm._v("\n        Optional Details\n      ")]
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c("v-stepper-step", { attrs: { step: "4" } }, [
                _vm._v("\n        Confirmation\n      ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-stepper-items",
            [
              _c(
                "v-stepper-content",
                { attrs: { step: "1" } },
                [
                  _vm.currentStep === 1
                    ? _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          true
                            ? _c(
                                "v-flex",
                                {
                                  staticClass: "pa-3",
                                  attrs: { xs12: "", md4: "" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { column: "" } },
                                    [
                                      _c(
                                        "v-list",
                                        {
                                          staticClass: "pb-0 mb-0",
                                          attrs: { subheader: "" }
                                        },
                                        [
                                          _c("v-subheader", [
                                            _vm._v("Created By")
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile",
                                            { attrs: { subheader: "" } },
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  items:
                                                    _vm.originatorCompanies,
                                                  readonly:
                                                    (_vm.originatorCompanies
                                                      .length || 0) == 1,
                                                  label: "Select Account",
                                                  "item-text":
                                                    "companyDisplayName",
                                                  "item-value": "companyId"
                                                },
                                                model: {
                                                  value: _vm.ownerCompanyId,
                                                  callback: function($$v) {
                                                    _vm.ownerCompanyId = $$v
                                                  },
                                                  expression: "ownerCompanyId"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list",
                                        [
                                          _c("v-subheader", [
                                            _vm._v("Customer Invoicing")
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile",
                                            { attrs: { subheader: "" } },
                                            [
                                              _c("v-checkbox", {
                                                staticClass: "mb-0 pb-0",
                                                attrs: {
                                                  label:
                                                    "Export Customer Invoice",
                                                  "data-vv-name": "loadCustomer"
                                                },
                                                model: {
                                                  value: _vm.hasCustomerCompany,
                                                  callback: function($$v) {
                                                    _vm.hasCustomerCompany = $$v
                                                  },
                                                  expression:
                                                    "hasCustomerCompany"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.ownerCompany &&
                                          _vm.ownerCompanyHasAccountingExportsEnabled
                                            ? _c(
                                                "v-radio-group",
                                                {
                                                  model: {
                                                    value:
                                                      _vm.customerExportSelection,
                                                    callback: function($$v) {
                                                      _vm.customerExportSelection = $$v
                                                    },
                                                    expression:
                                                      "customerExportSelection"
                                                  }
                                                },
                                                [
                                                  _vm.customerGroups > 1
                                                    ? _c(
                                                        "v-list-tile",
                                                        { staticClass: "pl-2" },
                                                        [
                                                          _c("v-radio", {
                                                            attrs: {
                                                              label:
                                                                "Site Account",
                                                              value: "platform",
                                                              disabled: !_vm.hasCustomerCompany
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.ownerCompanyHasQbConnected
                                                    ? _c(
                                                        "v-list-tile",
                                                        { staticClass: "pl-2" },
                                                        [
                                                          _c("v-radio", {
                                                            attrs: {
                                                              label:
                                                                "Quickbooks Customer",
                                                              value:
                                                                "quickbooks",
                                                              disabled: !_vm.hasCustomerCompany
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.customerExportSelection ===
                                            "platform" ||
                                          _vm.customerGroups == 1
                                            ? _c(
                                                "v-list-tile",
                                                [
                                                  _c("v-list-tile-avatar", [
                                                    _c("img", {
                                                      staticClass:
                                                        "align-center",
                                                      attrs: {
                                                        disabled: !_vm.hasCustomerCompany,
                                                        height: "38",
                                                        width: "38",
                                                        src: _vm.hasCustomerCompany
                                                          ? "/static/location-pin2.png"
                                                          : "/static/location-pin2-disabled.png"
                                                      }
                                                    })
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-combobox",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            rules: {
                                                              required:
                                                                _vm.hasCustomerCompany &&
                                                                _vm.customerExportSelection ===
                                                                  "platform"
                                                            }
                                                          },
                                                          expression:
                                                            "{ rules: { required: hasCustomerCompany && customerExportSelection === 'platform' } }"
                                                        }
                                                      ],
                                                      staticClass: "mb-4 mr-3",
                                                      attrs: {
                                                        disabled: !_vm.hasCustomerCompany,
                                                        items:
                                                          _vm.search &&
                                                          _vm.search.length > 3
                                                            ? _vm.allCompanies
                                                            : [],
                                                        "search-input":
                                                          _vm.search,
                                                        "hide-no-data": !(
                                                          _vm.search &&
                                                          _vm.search.length > 3
                                                        ),
                                                        "error-messages": _vm.errors.first(
                                                          "customerCompany",
                                                          "customerValidations"
                                                        ),
                                                        "data-vv-as":
                                                          "Customer Site Account",
                                                        "data-vv-name":
                                                          "customerCompany",
                                                        "data-vv-scope":
                                                          "customerValidations",
                                                        "item-text":
                                                          "searchName",
                                                        "return-object": "",
                                                        "hide-details": "",
                                                        label: "Select Account"
                                                      },
                                                      on: {
                                                        "update:searchInput": function(
                                                          $event
                                                        ) {
                                                          _vm.search = $event
                                                        },
                                                        "update:search-input": function(
                                                          $event
                                                        ) {
                                                          _vm.search = $event
                                                        }
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "item",
                                                            fn: function(data) {
                                                              return [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      color: _vm._.get(
                                                                        data,
                                                                        "item.accountStatus.verified",
                                                                        null
                                                                      )
                                                                        ? "green"
                                                                        : "transparent"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                        verified_user\n                      "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "ml-1"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        data
                                                                          .item
                                                                          .searchName
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        false,
                                                        1953771192
                                                      ),
                                                      model: {
                                                        value:
                                                          _vm.customerCompany,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.customerCompany = $$v
                                                        },
                                                        expression:
                                                          "customerCompany"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c(
                                                        "template",
                                                        { slot: "no-data" },
                                                        [
                                                          _c(
                                                            "v-list-tile",
                                                            [
                                                              _c(
                                                                "v-list-tile-content",
                                                                [
                                                                  _c(
                                                                    "v-list-tile-title",
                                                                    [
                                                                      _vm._v(
                                                                        '\n                            No results matching "'
                                                                      ),
                                                                      _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.search
                                                                            )
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        '".\n                            Press '
                                                                      ),
                                                                      _c(
                                                                        "kbd",
                                                                        [
                                                                          _vm._v(
                                                                            "tab"
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " to use this customer's name\n                          "
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.customerExportSelection ===
                                            "quickbooks" &&
                                          _vm.ownerCompanyHasQbConnected
                                            ? _c(
                                                "v-list-tile",
                                                [
                                                  _c("v-list-tile-action", [
                                                    _c("img", {
                                                      staticClass:
                                                        "align-center",
                                                      attrs: {
                                                        disabled: !_vm.hasCustomerCompany,
                                                        height: "38",
                                                        width: "38",
                                                        src: _vm.hasCustomerCompany
                                                          ? "/static/C2QB_white_btn_sm_default.png"
                                                          : "/static/C2QB_white_btn_sm_disabled.png"
                                                      }
                                                    })
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-select-quickbooks-company",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            rules: {
                                                              required:
                                                                _vm.hasCustomerCompany &&
                                                                _vm.customerExportSelection ===
                                                                  "quickbooks"
                                                            }
                                                          },
                                                          expression:
                                                            "{ rules: { required: hasCustomerCompany && customerExportSelection === 'quickbooks' } }"
                                                        }
                                                      ],
                                                      attrs: {
                                                        "error-messages": _vm.errors.first(
                                                          "customer"
                                                        ),
                                                        "data-vv-as":
                                                          "Customer",
                                                        "data-vv-name":
                                                          "customer",
                                                        "data-vv-scope":
                                                          "customerValidations",
                                                        company:
                                                          _vm.ownerCompany
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.customerQbCompany,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.customerQbCompany = $$v
                                                        },
                                                        expression:
                                                          "customerQbCompany"
                                                      }
                                                    }
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "sticky-footer",
                    [
                      !_vm.isDisabled
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "accent",
                                disabled: !_vm.stepOneCompleted
                              },
                              on: {
                                click: function($event) {
                                  _vm.currentStep = 2
                                }
                              }
                            },
                            [_vm._v("\n            Continue\n          ")]
                          )
                        : _c(
                            "v-btn",
                            {
                              staticClass: "accent mr-0",
                              attrs: { disabled: true }
                            },
                            [
                              _vm._v(
                                "\n            Account Disabled\n          "
                              )
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.$router.go(-1)
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-stepper-content",
                { attrs: { step: "2" } },
                [
                  _vm.currentStep === 2
                    ? _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "pa-3",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c("AddressSearch", {
                                attrs: {
                                  label: "From (Origin Address)",
                                  showPlaceHolder: !_vm.originLocation
                                },
                                model: {
                                  value: _vm.originLocation,
                                  callback: function($$v) {
                                    _vm.originLocation = $$v
                                  },
                                  expression: "originLocation"
                                }
                              }),
                              _vm._v(" "),
                              _c("AddressSearch", {
                                attrs: {
                                  label: "To (Destination Address)",
                                  showPlaceHolder:
                                    _vm.originLocation &&
                                    !_vm.destinationLocation
                                },
                                model: {
                                  value: _vm.destinationLocation,
                                  callback: function($$v) {
                                    _vm.destinationLocation = $$v
                                  },
                                  expression: "destinationLocation"
                                }
                              }),
                              _vm._v(" "),
                              _c("date-picker", {
                                attrs: {
                                  "input-id": "pickupTimePicker",
                                  placeholder: "Pickup Date"
                                },
                                model: {
                                  value: _vm.pickupTime,
                                  callback: function($$v) {
                                    _vm.pickupTime = $$v
                                  },
                                  expression: "pickupTime"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "mt-2",
                                attrs: {
                                  label: "Number of Trucks",
                                  type: "number"
                                },
                                model: {
                                  value: _vm.loadCount,
                                  callback: function($$v) {
                                    _vm.loadCount = $$v
                                  },
                                  expression: "loadCount"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "v-list__tile__sub-title" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.distanceLabel(_vm.loadedMiles)
                                      ) +
                                      ". Based on Google Maps\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pa-3",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c("LoadMap", {
                                attrs: {
                                  "origin-place-id": _vm.originPlaceId,
                                  editPosition: "",
                                  "destination-place-id": _vm.destinationPlaceId
                                },
                                on: {
                                  originChange: function($event) {
                                    return _vm.handleOriginChange($event)
                                  },
                                  destinationChange: function($event) {
                                    return _vm.handleDestinationChange($event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "sticky-footer",
                    [
                      !_vm.isDisabled
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "accent",
                                disabled: !_vm.stepTwoCompleted
                              },
                              on: {
                                click: function($event) {
                                  _vm.currentStep = 3
                                }
                              }
                            },
                            [_vm._v("\n            Continue\n          ")]
                          )
                        : _c(
                            "v-btn",
                            {
                              staticClass: "accent mr-0",
                              attrs: { disabled: true }
                            },
                            [
                              _vm._v(
                                "\n            Account Disabled\n          "
                              )
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              _vm.currentStep = 1
                            }
                          }
                        },
                        [_vm._v("Back")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-stepper-content",
                { attrs: { step: "3" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm6: "", "px-3": "" } },
                        [
                          _c(
                            "div",
                            { staticClass: "subheading font-weight-bold" },
                            [_vm._v("\n              Load Info\n            ")]
                          ),
                          _vm._v(" "),
                          _c("v-textarea", {
                            attrs: {
                              name: "input-7-4",
                              label: "Dispatcher Instructions"
                            },
                            model: {
                              value: _vm.dispatchInstructions,
                              callback: function($$v) {
                                _vm.dispatchInstructions = $$v
                              },
                              expression: "dispatchInstructions"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm6: "", "px-3": "" } },
                        [
                          _c(
                            "div",
                            { staticClass: "subheading font-weight-bold" },
                            [
                              _vm._v(
                                "\n              Requirements\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { row: "" } },
                            [
                              _c(
                                "v-list",
                                { attrs: { "two-line": "" } },
                                [
                                  _c(
                                    "v-list-tile",
                                    { staticClass: "optional-details-tile" },
                                    [
                                      _c(
                                        "v-list-tile-avatar",
                                        [
                                          _c(
                                            "icon-base",
                                            {
                                              attrs: {
                                                width: "35",
                                                height: "35",
                                                "icon-color": "#352208",
                                                "icon-name": "hose"
                                              }
                                            },
                                            [_c("icon-hose")],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        {
                                          staticClass:
                                            "optional-details-checkbox"
                                        },
                                        [
                                          _c("v-checkbox", {
                                            attrs: { label: "Washout" },
                                            model: {
                                              value: _vm.requireWashout,
                                              callback: function($$v) {
                                                _vm.requireWashout = $$v
                                              },
                                              expression: "requireWashout"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile",
                                    { staticClass: "optional-details-tile" },
                                    [
                                      _c(
                                        "v-list-tile-avatar",
                                        [
                                          _c(
                                            "icon-base",
                                            {
                                              attrs: {
                                                width: "35",
                                                height: "35",
                                                "icon-color": "#352208",
                                                viewBox: "0 0 5 5",
                                                "icon-name": "wood"
                                              }
                                            },
                                            [_c("icon-wood")],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        {
                                          staticClass:
                                            "optional-details-checkbox"
                                        },
                                        [
                                          _c("v-checkbox", {
                                            attrs: { label: "Wood Chips" },
                                            model: {
                                              value: _vm.requireWoodChips,
                                              callback: function($$v) {
                                                _vm.requireWoodChips = $$v
                                              },
                                              expression: "requireWoodChips"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile",
                                    { staticClass: "optional-details-tile" },
                                    [
                                      _c(
                                        "v-list-tile-avatar",
                                        [
                                          _c(
                                            "icon-base",
                                            {
                                              attrs: {
                                                width: "35",
                                                height: "35",
                                                "icon-name": "cold",
                                                "icon-color": "#352208"
                                              }
                                            },
                                            [_c("icon-cold")],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        {
                                          staticClass:
                                            "optional-details-checkbox"
                                        },
                                        [
                                          _c("v-checkbox", {
                                            attrs: { label: "Weatherboards" },
                                            model: {
                                              value: _vm.requireWeatherboards,
                                              callback: function($$v) {
                                                _vm.requireWeatherboards = $$v
                                              },
                                              expression: "requireWeatherboards"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", "pa-3": "" } },
                        [
                          _c("v-textarea", {
                            attrs: {
                              name: "input-7-4",
                              label: "Driver Instructions"
                            },
                            model: {
                              value: _vm.driverInstructions,
                              callback: function($$v) {
                                _vm.driverInstructions = $$v
                              },
                              expression: "driverInstructions"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "sticky-footer",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "accent",
                            disabled: !_vm.stepThreeCompleted
                          },
                          on: {
                            click: function($event) {
                              _vm.currentStep = 4
                            }
                          }
                        },
                        [_vm._v("\n            Continue\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              _vm.currentStep = 2
                            }
                          }
                        },
                        [_vm._v("Back")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-stepper-content",
                { attrs: { step: "4" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm6: "", "pa-3": "" } },
                        [
                          _c(
                            "div",
                            { staticClass: "headline font-weight-bold" },
                            [
                              _vm._v(
                                "\n              Load Details Confirmation\n            "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        {
                          staticClass: "hide-when-sticky-footer-visible",
                          attrs: { xs12: "", sm6: "", "pa-3": "" }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { "justify-end": "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    loading: _vm.loadingBtn,
                                    disabled: !_vm.confirmationIsValid,
                                    color: "accent"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.postLoad()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Save\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: { flat: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.currentStep = 3
                                    }
                                  }
                                },
                                [_vm._v("Back")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.currentStep === 4
                        ? _c(
                            "v-flex",
                            {
                              staticClass: "pl-3",
                              attrs: { xs12: "", sm6: "" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "subheading font-weight-bold" },
                                [
                                  _vm._v(
                                    "\n              Origination and Invoicing\n            "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "pl-3", attrs: { xs12: "", sm6: "" } },
                        [
                          _vm.currentStep === 4
                            ? _c(
                                "v-flex",
                                {
                                  staticClass: "pl-3",
                                  attrs: { xs12: "", sm6: "" }
                                },
                                [
                                  _c(
                                    "v-list",
                                    {
                                      staticClass: "pb-0 mb-0",
                                      attrs: { subheader: "" }
                                    },
                                    [
                                      _c("v-subheader", [_vm._v("Created By")]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        { attrs: { subheader: "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              items: _vm.originatorCompanies,
                                              readonly:
                                                (_vm.originatorCompanies
                                                  .length || 0) == 1,
                                              label: "Select Account",
                                              "item-text": "companyDisplayName",
                                              "item-value": "companyId"
                                            },
                                            model: {
                                              value: _vm.ownerCompanyId,
                                              callback: function($$v) {
                                                _vm.ownerCompanyId = $$v
                                              },
                                              expression: "ownerCompanyId"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.hasCustomerCompany
                                        ? _c("v-subheader", [
                                            _vm._v("Load Rate")
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasCustomerCompany
                                        ? _c(
                                            "v-list-tile",
                                            [
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _vm.billableAmount != null &&
                                                  this.originPlaceId != null &&
                                                  this.destinationPlaceId !=
                                                    null
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                    $" +
                                                            _vm._s(
                                                              _vm.loadedDistanceBilledRate
                                                            ) +
                                                            " per loaded " +
                                                            _vm._s(
                                                              _vm.siteDistanceMeasureUnitLabel
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c("v-list-tile-sub-title", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.distanceLabel(
                                                            _vm.loadedMiles
                                                          )
                                                        ) +
                                                        ". Based on Google Maps\n                    "
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasCustomerCompany
                                        ? _c("v-list-tile")
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "pl-3", attrs: { xs12: "", sm4: "" } },
                        [
                          _c(
                            "v-list",
                            { staticClass: "pt-0 pb-0 mt-0 b-0" },
                            [
                              _c("v-subheader", [_vm._v("Customer Invoicing")]),
                              _vm._v(" "),
                              _c(
                                "v-list-tile",
                                { staticClass: "mb-0 pb-0" },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "mb-0 pb-0",
                                    attrs: {
                                      label: "Export Customer Invoice",
                                      "data-vv-name": "loadCustomer"
                                    },
                                    model: {
                                      value: _vm.hasCustomerCompany,
                                      callback: function($$v) {
                                        _vm.hasCustomerCompany = $$v
                                      },
                                      expression: "hasCustomerCompany"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            {
                              staticClass: "pt-0 mt-0",
                              attrs: { "two-line": _vm.hasCustomerCompany }
                            },
                            [
                              _c(
                                "v-list-tile",
                                [
                                  _c(
                                    "v-list-tile-avatar",
                                    [_c("v-icon", [_vm._v("attach_money")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-float-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: !_vm.hasCustomerCompany
                                        },
                                        expression:
                                          "{ required: !hasCustomerCompany }"
                                      }
                                    ],
                                    staticClass: "pr-3",
                                    attrs: {
                                      label: "Invoiced Amount",
                                      disabled: !_vm.hasCustomerCompany,
                                      "error-messages": _vm.errors.first(
                                        "customerInvoiceAmount",
                                        "customerValidations"
                                      ),
                                      "data-vv-as": "Customer Invoice Amount",
                                      "data-vv-name": "customerInvoiceAmount",
                                      "data-vv-scope": "customerValidations"
                                    },
                                    model: {
                                      value: _vm.billableAmount,
                                      callback: function($$v) {
                                        _vm.billableAmount = $$v
                                      },
                                      expression: "billableAmount"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-list-tile-action")
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.ownerCompany &&
                              _vm.ownerCompanyHasAccountingExportsEnabled
                                ? _c(
                                    "v-radio-group",
                                    {
                                      model: {
                                        value: _vm.customerExportSelection,
                                        callback: function($$v) {
                                          _vm.customerExportSelection = $$v
                                        },
                                        expression: "customerExportSelection"
                                      }
                                    },
                                    [
                                      _vm.customerGroups > 1
                                        ? _c(
                                            "v-list-tile",
                                            { staticClass: "pl-2" },
                                            [
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "Site Account",
                                                  value: "platform",
                                                  disabled: !_vm.hasCustomerCompany
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.ownerCompanyHasQbConnected
                                        ? _c(
                                            "v-list-tile",
                                            { staticClass: "pl-2" },
                                            [
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "Quickbooks Customer",
                                                  value: "quickbooks",
                                                  disabled: !_vm.hasCustomerCompany
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.customerExportSelection === "platform" ||
                              _vm.customerGroups == 1
                                ? _c(
                                    "v-list-tile",
                                    [
                                      _c("v-list-tile-avatar", [
                                        _c("img", {
                                          staticClass: "align-center",
                                          attrs: {
                                            disabled: !_vm.hasCustomerCompany,
                                            height: "38",
                                            width: "38",
                                            src: _vm.hasCustomerCompany
                                              ? "/static/location-pin2.png"
                                              : "/static/location-pin2-disabled.png"
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-combobox",
                                        {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                rules: {
                                                  required:
                                                    _vm.hasCustomerCompany &&
                                                    _vm.customerExportSelection ===
                                                      "platform"
                                                }
                                              },
                                              expression:
                                                "{ rules: { required: hasCustomerCompany && customerExportSelection === 'platform' } }"
                                            }
                                          ],
                                          staticClass: "mb-4 mr-3",
                                          attrs: {
                                            disabled: !_vm.hasCustomerCompany,
                                            items:
                                              _vm.search &&
                                              _vm.search.length > 3
                                                ? _vm.allCompanies
                                                : [],
                                            "search-input": _vm.search,
                                            "hide-no-data": !(
                                              _vm.search &&
                                              _vm.search.length > 3
                                            ),
                                            "error-messages": _vm.errors.first(
                                              "customerCompany",
                                              "customerValidations"
                                            ),
                                            "data-vv-as":
                                              "Customer Site Account",
                                            "data-vv-name": "customerCompany",
                                            "data-vv-scope":
                                              "customerValidations",
                                            "item-text": "searchName",
                                            "return-object": "",
                                            "hide-details": "",
                                            label: "Select Account"
                                          },
                                          on: {
                                            "update:searchInput": function(
                                              $event
                                            ) {
                                              _vm.search = $event
                                            },
                                            "update:search-input": function(
                                              $event
                                            ) {
                                              _vm.search = $event
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "item",
                                                fn: function(data) {
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color: _vm._.get(
                                                            data,
                                                            "item.accountStatus.verified",
                                                            null
                                                          )
                                                            ? "green"
                                                            : "transparent"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      verified_user\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      { staticClass: "ml-1" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            data.item.searchName
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            2475501112
                                          ),
                                          model: {
                                            value: _vm.customerCompany,
                                            callback: function($$v) {
                                              _vm.customerCompany = $$v
                                            },
                                            expression: "customerCompany"
                                          }
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "template",
                                            { slot: "no-data" },
                                            [
                                              _c(
                                                "v-list-tile",
                                                [
                                                  _c(
                                                    "v-list-tile-content",
                                                    [
                                                      _c("v-list-tile-title", [
                                                        _vm._v(
                                                          '\n                          No results matching "'
                                                        ),
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(_vm.search)
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          '".\n                          Press '
                                                        ),
                                                        _c("kbd", [
                                                          _vm._v("tab")
                                                        ]),
                                                        _vm._v(
                                                          " to use this customer's name\n                        "
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.customerExportSelection === "quickbooks" &&
                              _vm.ownerCompanyHasQbConnected
                                ? _c(
                                    "v-list-tile",
                                    [
                                      _c("v-list-tile-action", [
                                        _c("img", {
                                          staticClass: "align-center",
                                          attrs: {
                                            disabled: !_vm.hasCustomerCompany,
                                            height: "38",
                                            width: "38",
                                            src: _vm.hasCustomerCompany
                                              ? "/static/C2QB_white_btn_sm_default.png"
                                              : "/static/C2QB_white_btn_sm_disabled.png"
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c("v-select-quickbooks-company", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: {
                                              rules: {
                                                required:
                                                  _vm.hasCustomerCompany &&
                                                  _vm.customerExportSelection ===
                                                    "quickbooks"
                                              }
                                            },
                                            expression:
                                              "{ rules: { required: hasCustomerCompany && customerExportSelection === 'quickbooks' } }"
                                          }
                                        ],
                                        attrs: {
                                          "error-messages": _vm.errors.first(
                                            "customer"
                                          ),
                                          "data-vv-as": "Customer",
                                          "data-vv-name": "customer",
                                          "data-vv-scope":
                                            "customerValidations",
                                          company: _vm.ownerCompany
                                        },
                                        model: {
                                          value: _vm.customerQbCompany,
                                          callback: function($$v) {
                                            _vm.customerQbCompany = $$v
                                          },
                                          expression: "customerQbCompany"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "", sm2: "" } }),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "pa-3", attrs: { xs12: "", sm6: "" } },
                        [
                          _c(
                            "div",
                            { staticClass: "subheading font-weight-bold" },
                            [
                              _vm._v(
                                "\n              Origin, Destination, Time\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("AddressSearch", {
                            attrs: {
                              label: "From (Origin Address)",
                              showPlaceHolder: !_vm.originLocation
                            },
                            model: {
                              value: _vm.originLocation,
                              callback: function($$v) {
                                _vm.originLocation = $$v
                              },
                              expression: "originLocation"
                            }
                          }),
                          _vm._v(" "),
                          _c("AddressSearch", {
                            attrs: {
                              label: "To (Destination Address)",
                              showPlaceHolder:
                                _vm.originLocation && !_vm.destinationLocation
                            },
                            model: {
                              value: _vm.destinationLocation,
                              callback: function($$v) {
                                _vm.destinationLocation = $$v
                              },
                              expression: "destinationLocation"
                            }
                          }),
                          _vm._v(" "),
                          _c("date-picker", {
                            attrs: {
                              "input-id": "pickupTimePickerPreview",
                              placeholder: "Pickup Date"
                            },
                            model: {
                              value: _vm.pickupTime,
                              callback: function($$v) {
                                _vm.pickupTime = $$v
                              },
                              expression: "pickupTime"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            staticClass: "mt-3",
                            attrs: {
                              label: "Number of Trucks",
                              type: "number"
                            },
                            model: {
                              value: _vm.loadCount,
                              callback: function($$v) {
                                _vm.loadCount = $$v
                              },
                              expression: "loadCount"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "pa-3", attrs: { sm6: "" } },
                        [
                          _c("LoadMap", {
                            attrs: {
                              "origin-place-id": _vm.originPlaceId,
                              editPosition: "",
                              "destination-place-id": _vm.destinationPlaceId
                            },
                            on: {
                              originChange: function($event) {
                                return _vm.handleOriginChange($event)
                              },
                              destinationChange: function($event) {
                                return _vm.handleDestinationChange($event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm6: "", "pa-3": "" } },
                        [
                          _c(
                            "div",
                            { staticClass: "subheading font-weight-bold" },
                            [_vm._v("\n              Load Info\n            ")]
                          ),
                          _vm._v(" "),
                          _c("v-textarea", {
                            attrs: {
                              name: "input-7-4",
                              label: "Dispatcher Instructions"
                            },
                            model: {
                              value: _vm.dispatchInstructions,
                              callback: function($$v) {
                                _vm.dispatchInstructions = $$v
                              },
                              expression: "dispatchInstructions"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm6: "", "pa-3": "" } },
                        [
                          _c(
                            "div",
                            { staticClass: "subheading font-weight-bold" },
                            [
                              _vm._v(
                                "\n              Requirements\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { row: "" } },
                            [
                              _c(
                                "v-list",
                                { attrs: { "two-line": "" } },
                                [
                                  _c(
                                    "v-list-tile",
                                    [
                                      _c(
                                        "v-list-tile-avatar",
                                        [
                                          _c(
                                            "icon-base",
                                            {
                                              attrs: {
                                                width: "35",
                                                height: "35",
                                                "icon-color": "#352208",
                                                "icon-name": "hose"
                                              }
                                            },
                                            [_c("icon-hose")],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        {
                                          staticClass:
                                            "optional-details-checkbox"
                                        },
                                        [
                                          _c("v-checkbox", {
                                            attrs: {
                                              label: "Washout",
                                              "hide-details": ""
                                            },
                                            model: {
                                              value: _vm.requireWashout,
                                              callback: function($$v) {
                                                _vm.requireWashout = $$v
                                              },
                                              expression: "requireWashout"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile",
                                    [
                                      _c(
                                        "v-list-tile-avatar",
                                        [
                                          _c(
                                            "icon-base",
                                            {
                                              attrs: {
                                                width: "35",
                                                height: "35",
                                                "icon-color": "#352208",
                                                viewBox: "0 0 5 5",
                                                "icon-name": "wood"
                                              }
                                            },
                                            [_c("icon-wood")],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        {
                                          staticClass:
                                            "optional-details-checkbox"
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "no-messages",
                                            attrs: {
                                              label: "Wood Chips",
                                              "hide-details": ""
                                            },
                                            model: {
                                              value: _vm.requireWoodChips,
                                              callback: function($$v) {
                                                _vm.requireWoodChips = $$v
                                              },
                                              expression: "requireWoodChips"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile",
                                    [
                                      _c(
                                        "v-list-tile-avatar",
                                        [
                                          _c(
                                            "icon-base",
                                            {
                                              attrs: {
                                                width: "35",
                                                height: "35",
                                                "icon-name": "cold",
                                                "icon-color": "#352208"
                                              }
                                            },
                                            [_c("icon-cold")],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        {
                                          staticClass:
                                            "optional-details-checkbox"
                                        },
                                        [
                                          _c("v-checkbox", {
                                            attrs: {
                                              label: "Weatherboards",
                                              "hide-details": ""
                                            },
                                            model: {
                                              value: _vm.requireWeatherboards,
                                              callback: function($$v) {
                                                _vm.requireWeatherboards = $$v
                                              },
                                              expression: "requireWeatherboards"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", "pa-3": "" } },
                        [
                          _c("v-textarea", {
                            attrs: {
                              name: "input-7-4",
                              label: "Driver Instructions"
                            },
                            model: {
                              value: _vm.driverInstructions,
                              callback: function($$v) {
                                _vm.driverInstructions = $$v
                              },
                              expression: "driverInstructions"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "sticky-footer",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            loading: _vm.loadingBtn,
                            disabled: !_vm.confirmationIsValid,
                            color: "accent"
                          },
                          on: {
                            click: function($event) {
                              return _vm.postLoad()
                            }
                          }
                        },
                        [_vm._v("\n            Save\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              _vm.currentStep = 3
                            }
                          }
                        },
                        [_vm._v("Back")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("explain-this", { attrs: { video: "post-load" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60a6516c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60a6516c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PostLoad.vue
// module id = null
// module chunks = 